import React, { FC, useEffect, useState } from "react";
import { FormSelectInput } from "stentor-models";

import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";

import { Styleable } from "../../types";

import { FormFieldProps } from "../FormDisplay";

import styles from "./FormFieldSelect.module.scss";

export interface FormSelectProps extends FormFieldProps {
    readonly field: Styleable<FormSelectInput>;
}

export const FormFieldSelect: FC<FormSelectProps> = (props) => {
    const { field, onFieldChange, errorMessage } = props;

    const [selectValue, setSelectValue] = useState<string[]>([]); // array for checkboxes
    const [radioValue, setRadioValue] = useState<string>(""); // single value for radio

    const onCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setSelectValue((prevOptions) => {
            if (checked) {
                return [...prevOptions, name];
            } else {
                return prevOptions.filter((option) => option !== name);
            }
        });
    };

    const onRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRadioValue(e.target.value);
    };

    useEffect(() => {
        if (field.radio) {
            onFieldChange(field.name, radioValue ? [radioValue] : []);
        } else {
            onFieldChange(field.name, selectValue);
        }
    }, [selectValue, radioValue, field.name, field.radio, onFieldChange]);

    return (
        <div style={{ ...field.style }}>
            <div
                className={`${styles.xapp_select_title_container}${!field.title ? "__empty" : ""}`}>
                <p>{field.title}</p>
            </div>

            <div className={styles.xapp_select_container}>
                {field.radio ? (
                    <RadioGroup
                        value={radioValue}
                        onChange={onRadioChange}
                        row
                    >
                        {field.items.map((item) => (
                            <FormControlLabel
                                key={item.id}
                                value={item.id}
                                control={
                                    <Radio
                                        color="primary"
                                        className={`${styles.xapp_checkbox_select}`}
                                    />
                                }
                                label={item.label}
                            />
                        ))}
                    </RadioGroup>
                ) : (
                    field.items.map((item) => (
                        <FormControlLabel
                            key={item.id}
                            control={
                                <Checkbox
                                    checked={selectValue.includes(item.id)}
                                    onChange={onCheckboxChange}
                                    name={item.id}
                                    color="primary"
                                    className={`${styles.xapp_checkbox_select}`}
                                />
                            }
                            label={item.label}
                        />
                    ))
                )}
            </div>

            {errorMessage && (
                <FormHelperText error style={{ marginLeft: "14px" }}>
                    {errorMessage}
                </FormHelperText>
            )}
        </div>
    );
};

export default FormFieldSelect;
